import React from 'react'
import MarkPackagedPage from './MarkPackagedPage'
import '../styles/index.scss'

function MarkPackagedPageContainer() {
    return (
        <div className="MarkPackagedPageContainer">
            <MarkPackagedPage/>
        </div>
    )
}

export default MarkPackagedPageContainer